import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseView } from '../../models/caseview.model';

export interface Sender {
  alphanum_Fileno: number;
  process: string;
  recipient: any;
  // target:string;
}

@Component({
  selector: 'app-pendency',
  templateUrl: './pendency.component.html',
  styleUrls: ['./pendency.component.scss'],
})
export class PendencyComponent implements OnInit {
  case: CaseView;
  selectedVal = 'Tabular';

  constructor(@Inject(MAT_DIALOG_DATA) public data: CaseView[]) {
    this.case = data[0];
  }
  ngOnInit(): void {
    console.log();
  }

  onValChange(val: string): void {
    this.selectedVal = val;
  }
}
